var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _rect7, _g, _path9, _path10, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 100C180 111.881 177.405 123.168 172.746 133.308C160.119 160.865 132.292 180 100 180C67.7081 180 39.8811 160.865 27.2541 133.308C22.5946 123.168 20 111.881 20 100C20 55.8162 55.8162 20 100 20C144.184 20 180 55.8162 180 100Z",
    fill: "#D9F3EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8003 116.898C34.8357 116.898 29.9996 121.734 29.9995 127.698V133.099H123.6C119.127 133.099 115.5 129.472 115.5 124.998C115.5 120.525 119.127 116.898 123.6 116.898H40.8003Z",
    fill: "url(#paint0_linear_345_22992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 127.698C93 121.734 88.1647 116.898 82.2 116.898H42.6V143.898C42.6 149.863 47.4353 154.698 53.4 154.698H93V127.698Z",
    fill: "url(#paint1_linear_345_22992)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4001 54.8C62.4001 48.8353 67.2355 44 73.2001 44H143.4V135.8C143.4 146.238 134.938 154.7 124.5 154.7H62.4001V54.8Z",
    fill: "url(#paint2_linear_345_22992)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.4 44L143.956 44.0137C149.662 44.3031 154.2 49.0217 154.2 54.7998C154.2 60.578 149.662 65.2965 143.956 65.5859L143.4 65.5996H70.5C76.4647 65.5996 81.2998 60.7645 81.2998 54.7998C81.2997 48.8352 76.4646 44 70.5 44H143.4Z",
    fill: "url(#paint3_linear_345_22992)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3997 144.799C62.3997 150.266 57.9678 154.699 52.5002 154.699H62.3997V144.799Z",
    fill: "#00412B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0005 116.9C40.9885 116.901 42.6001 118.512 42.6001 120.5L42.6001 116.9L39.0005 116.9Z",
    fill: "#005428"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 95.3008,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 95.3008,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 111.5,
    width: 36.9,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 111.5,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6001,
    y: 79.1016,
    width: 46.8,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 79.1016,
    width: 7.2,
    height: 7.2,
    rx: 2.7,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.397 107.113C167.588 106.392 168.327 105.961 169.047 106.151L171.658 106.841C172.378 107.031 172.809 107.77 172.619 108.49C172.428 109.211 171.69 109.642 170.969 109.452L168.358 108.762C167.637 108.572 167.207 107.833 167.397 107.113ZM171.157 98.2114C171.848 97.9313 172.635 98.2639 172.915 98.9548C173.195 99.6458 172.862 100.433 172.171 100.714L169.668 101.728C168.978 102.007 168.19 101.675 167.91 100.984C167.63 100.293 167.964 99.5055 168.654 99.2254L171.157 98.2114ZM163.503 93.13C163.686 92.4073 164.42 91.9699 165.143 92.1527C165.865 92.3355 166.304 93.0693 166.121 93.792L165.459 96.4099C165.276 97.1327 164.541 97.5705 163.818 97.3876C163.096 97.2047 162.658 96.4706 162.841 95.7479L163.503 93.13Z",
    fill: "#A1A5AC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153.409,
    y: 132.688,
    width: 1.80469,
    height: 11.4449,
    transform: "rotate(-45 153.409 132.688)",
    stroke: "url(#paint4_linear_345_22992)",
    strokeWidth: 1.80469
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_345_22992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.73 139.647C154.324 138.241 154.324 135.962 155.73 134.556L156.553 133.732C157.959 132.326 160.239 132.326 161.645 133.732L174.569 146.657C175.975 148.063 175.975 150.342 174.569 151.748L173.746 152.572C172.34 153.978 170.06 153.978 168.654 152.572L155.73 139.647Z",
    fill: "url(#paint5_linear_345_22992)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.3 113.302C162.3 127.219 151.017 138.502 137.1 138.502C123.182 138.502 111.9 127.219 111.9 113.302C111.9 99.384 123.182 88.1016 137.1 88.1016C151.017 88.1016 162.3 99.384 162.3 113.302Z",
    fill: "#D9DCE0",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.1 130.402C146.544 130.402 154.2 122.746 154.2 113.302C154.2 103.857 146.544 96.2016 137.1 96.2016C127.656 96.2016 120 103.857 120 113.302C120 122.746 127.656 130.402 137.1 130.402ZM137.1 138.502C151.017 138.502 162.3 127.219 162.3 113.302C162.3 99.384 151.017 88.1016 137.1 88.1016C123.182 88.1016 111.9 99.384 111.9 113.302C111.9 127.219 123.182 138.502 137.1 138.502Z",
    fill: "url(#paint6_linear_345_22992)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_345_22992)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 156.354,
    y1: 140.646,
    x2: 171.354,
    y2: 155.646,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_345_22992",
    x: 153.775,
    y: 130.88,
    width: 21.8487,
    height: 22.7453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.9,
    dy: -1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362969 0 0 0 0 0.386115 0 0 0 0 0.420833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_345_22992"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_345_22992",
    x: 152,
    y: 136.293,
    width: 23.707,
    height: 23.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_345_22992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_22992",
    x1: 74.3504,
    y1: 132.607,
    x2: 74.3678,
    y2: 117.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953081,
    stopColor: "#0A5239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_345_22992",
    x1: 66.4811,
    y1: 153.552,
    x2: 66.6572,
    y2: 118.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639423,
    stopColor: "#065238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_345_22992",
    x1: 105.02,
    y1: 151.342,
    x2: 104.746,
    y2: 76.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_345_22992",
    x1: 114.54,
    y1: 64.9444,
    x2: 114.506,
    y2: 45.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953081,
    stopColor: "#0A5239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_345_22992",
    x1: 152.456,
    y1: 134.58,
    x2: 157.619,
    y2: 135.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_345_22992",
    x1: 170.425,
    y1: 139.878,
    x2: 154.438,
    y2: 152.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_345_22992",
    x1: 116.4,
    y1: 95.3016,
    x2: 162.3,
    y2: 132.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB0B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.4e88e3b55b3cc7b1264ad3482df9dab0.svg";
export { ForwardRef as ReactComponent };